import React from 'react';
import { Checkbox, OriSelect } from 'src/components/Antd';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { Field } from 'src/components/RcForm';
import {
  actionButtonTheme,
  leaveGap,
  scrollOut,
} from 'src/tools/contentModulesFieldName';
//import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { sectionProps } from 'src/tools/constant';
import { i18nGet } from 'src/tools/tools';
import { EnumModuleType } from 'src/types/common/module';

const Option = OriSelect.Option;
const LeaveGapBetween = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { disabled, options, moduleType } = props;

  const checkboxGenerator = () => {
    if (
      moduleType === EnumModuleType.ResponsiveProductCarousel ||
      moduleType === EnumModuleType.ResponsiveProductGrid ||
      moduleType === EnumModuleType.ResponsiveProductTab
    ) {
      return getI18n('salesChannelContent.index.leavegapbetweenproducts');
    }
    if (
      moduleType === EnumModuleType.ResponsiveContentCarousel ||
      moduleType === EnumModuleType.ResponsiveContentGrid ||
      moduleType === EnumModuleType.ResponsiveContentTab
    ) {
      return getI18n('general.leavegapbetweencontentpages');
    }
  };

  const titleGenerator = () => {
    if (moduleType === EnumModuleType.ResponsiveProductCarousel) {
      return getI18n('general.scrolledOutProductsNumber');
    }
    if (moduleType === EnumModuleType.ResponsiveContentCarousel) {
      return getI18n('general.scrolledOutContentPagesNumber');
    }
    if (moduleType === EnumModuleType.ResponsiveProductGrid) {
      return `${getI18n('general.callToActionButtonTheme')}(${getI18n(
        'general.optional',
      )})`;
    }
  };

  const selectNameGenerator = () => {
    if (moduleType === EnumModuleType.ResponsiveProductGrid) {
      return actionButtonTheme;
    }
    if (moduleType === EnumModuleType.ResponsiveProductCarousel) {
      return scrollOut;
    }
    if (moduleType === EnumModuleType.ResponsiveContentCarousel) {
      return scrollOut;
    }
  };

  const leaveGapDisplay =
    //also Call To Action Button Theme(Optional)
    [
      EnumModuleType.ResponsiveProductCarousel,
      EnumModuleType.ResponsiveContentCarousel,
      EnumModuleType.ResponsiveContentGrid,
      EnumModuleType.ResponsiveProductGrid,
      EnumModuleType.ResponsiveProductTab,
      EnumModuleType.ResponsiveContentTab,
    ].includes(moduleType);

  const scrollOutDisplay =
    //also Call To Action Button Theme(Optional)
    [
      EnumModuleType.ResponsiveProductCarousel,
      EnumModuleType.ResponsiveContentCarousel,
    ].includes(moduleType);

  return (
    <Section {...sectionProps}>
      {leaveGapDisplay && (
        <ItemWrapper>
          <Field name={leaveGap} valuePropName={'checked'}>
            <Checkbox disabled={disabled}>{checkboxGenerator()}</Checkbox>
          </Field>
        </ItemWrapper>
      )}

      {scrollOutDisplay && (
        <ItemWrapper title={titleGenerator()}>
          <Field name={selectNameGenerator()}>
            <OriSelect disabled={disabled} size='large'>
              {options.map((i) => {
                const { label, value } = i;
                return (
                  <Option value={value} key={value}>
                    {label}
                  </Option>
                );
              })}
            </OriSelect>
          </Field>
        </ItemWrapper>
      )}
    </Section>
  );
};
export default LeaveGapBetween;
